import "./App.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./Component/MainComponent/LoginPage/LoginPage";
import { ToastContainer } from "react-toastify";
import Navbar from "./Component/AppComponent/Navbar/Navbar";
import SideBar from "./Component/AppComponent/SideBar/SideBar";
import Role from "./Pages/Home/Role";

import Loader from "./Component/AppComponent/Loader";
// import RoleCreateForm from "./Component/MainComponent/Role/RoleCreateForm";
import CreateMail from "./Pages/Home/CreateMail";
import Sent from "./Pages/SentPage/Sent";
import Scheduled from "./Pages/Scheduled/Scheduled";
import CreateUser from "./Pages/CreateUser/CreateUser";
import CreateUserForm from "./Pages/CreateUser/CreateUserForm";
import PlantProject from "./Pages/PlantProject/PlantProject";
import ProjectTemplate from "./Pages/PlantProject/ProjectTemplate";
import ProjectWpsTemplate from "./Pages/PlantProject/ProjectWpsTemplate";
import axios from "axios";
import { store } from "./Redux/Store";
import { invoiceget } from "./Context/apidata";
import { useNavigate } from "react-router-dom";
import ErrorPage from "./Component/AppComponent/error/error";
import Dashboard from "./Pages/Home/Dashboard";
import Graphs from "./Pages/Graph/Graphs";
import ProjectsView from "./Pages/Graph/projectsView";
import ForgotPassword from "./Component/MainComponent/LoginPage/ForgotPassword";
import VerifyOtp from "./Component/MainComponent/LoginPage/VerifyOtp";
import PasswordReset from "./Component/MainComponent/LoginPage/PasswordReset";
function App() {
  const userToken = useSelector(
    (state) => state?.users?.UserData?.session?.token,
  );
  //console.log(userToken)
  const [Token, setTokens] = useState(null);
  const dispatch = useDispatch();
  const UserData = useSelector((state) => state.users.UserData);
  const [Loader1, setLoader] = useState(false);
  const LoaderData = useSelector((state) => state.Loader);
  const [errorstatus, seterrorstatus] = useState("");
  const [errornav, seterrornav] = useState("");
  const navigate = useNavigate();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([it, it]);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  useEffect(() => {
    setLoader(LoaderData.isLoading);
  }, [LoaderData.isLoading]);

  useEffect(() => {
    if (UserData.session) {
      setTokens(UserData.session.token);
    }
  }, [UserData]);

  useEffect(() => {
    if (userToken?.length > 0) {
      axios({
        url: invoiceget,
        method: "get",
        params: {
          search: "",
          date_gt: range[0],
          date_lt: range[1],
          page: 1,
        },
        headers: {
          Authorization:
            "Bearer " + store?.getState()?.users?.UserData?.session?.token,
        },
      })
        .then((res) => {})
        .catch((error) => {
          seterrorstatus(error?.response?.status);
          //console.log(error.response.status,"kahdgaj")
          if (error.response.status) {
            seterrornav("/");
            navigate("/Error");
          }
        });
    }
  }, [Loader1]);

  return (
    <>
      {Loader1 && <Loader />}
      <div className="App">
        {/* {localStorage.getItem("login") == "false" ? null : null} */}
        {userToken?.length > 0 ? (
          <>
            <>
              <Navbar />
              <SideBar />
              <Routes>
                <Route path="/" element={<Role />} />
                <Route path="/create_schedule" element={<CreateMail />} />
                <Route path="/dashBoard" element={<Dashboard />} />
                <Route path="/sent" element={<Sent />} />
                <Route path="/scheduled" element={<Scheduled />} />
                <Route path="/createUser" element={<CreateUser />} />
                <Route path="/createuserform" element={<CreateUserForm />} />
                <Route path="/plantProject" element={<PlantProject />} />
                <Route path="/graphs" element={<Graphs />} />
                <Route
                  path="/graphs/:projectName/:id"
                  element={<ProjectsView />}
                />
                <Route path="/projects/:id" element={<ProjectTemplate />} />
                <Route
                  path="/projectWps/:id"
                  element={<ProjectWpsTemplate />}
                />
                <Route
                  path="/Error"
                  element={
                    <ErrorPage errorstatus={errorstatus} errornav={errornav} />
                  }
                ></Route>
              </Routes>
            </>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/verifyotp" element={<VerifyOtp />} />
              <Route path="/resetpassword" element={<PasswordReset />} />
            </Routes>
          </>
        )}
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
